import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect, Component } from 'react';
import {appendScript, renderTime} from './appendScript'
import Instructions from './Instructions';
import {timerFunc} from './timerFunc';
import ReactCountdownClock from 'react-countdown-clock'
import { CountdownCircleTimer, useCountdown } from 'react-countdown-circle-timer'

//https://codesandbox.io/s/tender-bogdan-qd35m?file=/src/index.js
//https://github.com/vydimitrov/react-countdown-circle-timer/tree/master/packages/mobile#react-native-countdown-circle-timer
class App extends Component {

  constructor(props){
    super(props);
    this.state = {
      data: 'constructor called'
    }
  }

  componentWillMount(){
    console.log('componentWillMount called');
  }

  getData(){
    setTimeout(() => {
      console.log('getData 1');
      this.setState({
        data: 'getData 2'
      })
    }, 1000)
  }

  componentDidMount(){
    this.getData();
  }

  myCallback(){
  }

  render() {
    return(
        <div style={{
            position: 'absolute', left: '50%', top: '50%',
            transform: 'translate(-50%, -50%)', width: '600px', height: '600px'
        }}>
            <h1>Time until release</h1>
            <div className="timer-wrapper" style={{position: 'absolute', left: '50%', top: '50%',
                transform: 'translate(-50%, -50%)'}}>
                <CountdownCircleTimer
                  key={0}
                  isPlaying
                  duration={timerFunc()}
                  colors="#7E2E84"
                  onComplete={() => [true, 1000]}
                  size = '400'
                  children = {({ remainingTime }) => {
                      const hours = Math.floor(remainingTime / 3600)
                      const minutes = Math.floor((remainingTime % 3600) / 60)
                      const seconds = remainingTime % 60

                      return hours + ':' + minutes + ':' + seconds
                  }}
                >

                </CountdownCircleTimer>
            </div>
        </div>
    )
  }
}

export default App;
